import React from 'react'
import { css } from '@emotion/core'
import { v4 } from 'uuid'

const rowStyle = css`
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
`
const labelStyle = css`
  color: grey;
  font-size: 0.75rem;
`
const detailStyle = css`
  font-size: 0.9rem;
`
const DataColumnView = ({ data }) => {
  const getColumnCount = () => {
    const screenWidth = window.innerWidth
    if (screenWidth <= 600) {
      return 1
    }
    if (screenWidth <= 800) {
      return 2
    }
    if (screenWidth <= 1200) {
      return 3
    }
    return 4
  }

  const numColumns = getColumnCount()

  if (data === null || data === undefined) return <>DataView: Nothing to display!</>
  return (
    <div
      css={css`
        column-count: ${numColumns};
        column-gap: 1em;
        margin-bottom: 0;
        padding: 0.5em 1em;
        border: 1px solid #d7d7d7;
        border-radius: 5px;
        box-shadow: 0px 1px #bfbfbf;
        break-inside: avoid;

        /* Add custom row dividers */
        & > * {
          border-bottom: 1px solid #d7d7d7;
        }
      `}
    >
      {data.map((item) => {
        let label = null
        if (item.label) {
          label = <>{item.label}: </>
        }
        return (
          <div css={rowStyle} key={item.key ? item.key : v4()} data-testid={`${item.label}-div`}>
            <span css={labelStyle} data-testid={`${item.label}-label`}>
              {label}
            </span>
            <span css={detailStyle} data-testid={`${item.label}-value`}>
              {item.detail}
            </span>
          </div>
        )
      })}
    </div>
  )
}
export default DataColumnView
